import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { TagDto } from '@/api';

interface TagsProps {
  tags?: TagDto[];
  truncated?: boolean;
}

const MAX_TAGS = 1
const CLOSE_DELAY = 1000

export default /*#__PURE__*/_defineComponent({
  __name: 'Tags',
  props: {
  tags: { default: () => [] },
  truncated: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;




let isInTooltip = _ref(false);
let tooltipVisible = _ref(false);
let isInPlusTag = _ref(false);


const openTooltip = () => {
  tooltipVisible.value = true;
  isInTooltip.value = false;
  isInPlusTag.value = true;
};

const closeTooltip = () => {
  isInPlusTag.value = false;
  setTimeout(() => {
    if (!isInTooltip.value) tooltipVisible.value = false;
  }, 400);
};

const handleMouseEnter = () => {
  isInTooltip.value = true;
  tooltipVisible.value = true;
  isInPlusTag.value = false;
};

const handleMouseLeave = () => {
  isInTooltip.value = false;
  setTimeout(() => {
    if (!isInPlusTag.value) tooltipVisible.value = false;
  }, CLOSE_DELAY);
};

const isTruncated = _computed(() => props.truncated && props.tags.length > MAX_TAGS);
const truncatedTags = _computed(() => (props.truncated ? props.tags.slice(0, MAX_TAGS) : props.tags));
const otherTags = _computed(() => (props.truncated ? props.tags.slice(MAX_TAGS) : []));
const plusTag = _computed(() => ({
    id: 'plus',
    name: `+${props.tags.length - MAX_TAGS}`,
  }));


return { __sfc: true,MAX_TAGS, CLOSE_DELAY, props, isInTooltip, tooltipVisible, isInPlusTag, openTooltip, closeTooltip, handleMouseEnter, handleMouseLeave, isTruncated, truncatedTags, otherTags, plusTag, _ref, _computed, TagDto }
}

})